window.projectDetailsHandler = () => {
  document.addEventListener("DOMContentLoaded", () => {
    scrollToContainer();
  });

  const scrollToContainer = function () {
    $('.jsScrollTo').click(function (e) {
      e.preventDefault();
      const destination = "#" + $(this).data('dest');
      const navigationBarHeight = $('.navigationBar').height();

      scrollToDest(destination, navigationBarHeight * (-1));
    });
  };
};